import { combineReducers } from "redux";
import recording_list from "../features/admin/recording_list/Slice";

const RecordingListData = combineReducers({
  recording_list: recording_list,
});

export default RecordingListData;
